module.exports = __webpack_public_path__ + "img/1900f.369b8e86.png";